// /loading.js
import { ElLoading } from 'element-plus'

export default {
  install(app) {
    // 默认配置
    const defaultOptions = {
      lock: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.7)'
    }
    
    // 挂载全局方法
    app.config.globalProperties.$loading = {
      show(options = {}) {
        return ElLoading.service({ ...defaultOptions, ...options })
      },
      hide(instance) {
        instance?.close()
      }
    }
  }
}